var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-embed',{attrs:{"type":"iframe","src":this.data,"allowfullscreen":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }